import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageNotFoundView } from './features/not-found/PageNotFoundView';
import { StartViewNew } from './features/landing-page/StartViewNew';
import { PriceList } from './features/price-list/PriceList';
import { PrivacyPolicy } from './features/privacy-policy/PrivacyPolicy';

export const Router: FC = () => (
  <Routes>
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/price-list" element={<PriceList />} />
    <Route path="/priceList" element={<PriceList />} />
    <Route path="/" element={<StartViewNew />} />
    <Route path="*" element={<PageNotFoundView />} />
  </Routes>
);
